import {
    ApolloClient,
    ApolloLink,
    concat,
    HttpLink,
    InMemoryCache,
} from "@apollo/client";

const httpLink = new HttpLink({ uri: process.env.REACT_APP_BACKEND });

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      access_token: `${localStorage.getItem('token')}` || null,
    }
  }));

  return forward(operation);
})
const connectApolloClient = ()=>{
    const client = new ApolloClient({
        link: concat(authMiddleware, httpLink),
        cache: new InMemoryCache(),        
    });
    return client;
}


export {
    connectApolloClient
}